// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nh-0";
export var assigneeDetails = "_nh-1";
export var assigneeInfo = "_nh-2";
export var dropdownContainer = "_nh-4";
export var dropdownImage = "_nh-5";
export var editAssigneeInfo = "_nh-3";
export var editAssigneeModalContainer = "_nh-6";
export var hidden = "_nh-8";
export var input = "_nh-7";